import { render, staticRenderFns } from "./header-order-list.vue?vue&type=template&id=782b5d4b&"
import script from "./header-order-list.vue?vue&type=script&lang=ts&"
export * from "./header-order-list.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports